import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AcTranslationService } from '@core/services/translation/ac-translation.service';
import { NgTemplateOutlet } from '@angular/common';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { RouterLink } from '@angular/router';
import { StoreState } from '@store/store.state';
import { Store } from '@ngrx/store';
import { userSelectors } from '@store/selectors/user.selectors';
import { Help } from '@shared/constants/help';

@Component({
  selector: 'ac-spanish-privacy-policy',
  standalone: true,
  imports: [NgTemplateOutlet, RouterLink],
  templateUrl: './spanish-privacy-policy.component.html',
  styles: `
    :host {
      display: block;
    }
  `,
  host: {
    class: 'parsed-html',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpanishPrivacyPolicyComponent {
  protected readonly _currentLangSig = inject(AcTranslationService).langSig;
  protected readonly _phoneNumber = Help.PHONE;
  protected readonly _protectDataContactEmail = 'protecciondedatosenergia@acciona.com';
  protected readonly _helpEmailSig = inject(Store<StoreState>).selectSignal(userSelectors.helpEmail);
  protected readonly _thirdPartyEuClausesWeb =
    'https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/standard-contractual-clauses-scc_es';

  protected readonly _cookiesRoute = AcRoutingService.COOKIES_ROUTE();
}
